define(function() {
	var IpsModelCollection = require('civicsBase/ipsModelCollection');

	return IpsModelCollection.extend({
		urlRoot: '/delegate/civics-api/api/cdr/inspections/{0}/{1}/results',
		url: function() {
			return this.urlRoot.format(this.type, this.id);
		},
		parse:function(r){
		  _.each(r.data, function (item) {
			  if( item.description == null || item.description.trim().length <= 0 ){
					item.description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
			  }
		  });

		  this.responseStatus = r.responseStatus;
		  return r.data;
		}
	});
});
